import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FirestoreWork } from '@jessie/commons';
import { TailwindButtonDirective } from '../../../../components/button/tailwind-button.directive';

@Component({
  selector: 'app-work-suggestions',
  standalone: true,
  imports: [TailwindButtonDirective],
  template: `
    <div class="mt-4">
      <h2 class="text-sm font-medium text-fg-secondary mb-2">Vorschläge basierend auf deinen letzten Buchungen</h2>
      <div class="flex flex-wrap gap-2">
        @for (suggestion of suggestions; track suggestion.id) {
          <button
            type="button"
            appTailwindButton
            color="white"
            size="xs"
            (click)="selectSuggestion.emit(suggestion)"
            class="text-xs py-1 px-2 h-auto"
          >
            <span class="font-semibold">{{ suggestion.data.project.displayName }}</span>
            <span class="mx-1">·</span>
            <span class="truncate max-w-[150px]">{{ suggestion.data.position.displayName }}</span>
          </button>
        }
      </div>
    </div>
  `,
})
export class WorkSuggestionsComponent {
  @Input({ required: true }) suggestions: FirestoreWork[] = [];
  @Output() selectSuggestion = new EventEmitter<FirestoreWork>();
}
